import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";

export default function DataTable_Component({
  columns,
  apidata = [],
  totalRows = 0,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  dataFilter,
  setDataFilter,

  totalPendingChallans = 0,
  totalPendingChallanAmount = 0,
  totalChallans = 0,
  totalChallanAmount = 0,
  // These must come from vehicleChallan.js
  selectedHubIds = [],
  setSelectedHubIds,
  applyFilters,
  removeFilters,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [hubs, setHubs] = useState([]);

  const userRole = localStorage.getItem("userRole");
  const showHubFilter = userRole?.toLowerCase() === "superadmin";
  useEffect(() => {
    if (!showHubFilter) return;

    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setHubs(response.data.hubs || []);
      } catch (error) {
        console.error("Hub fetch error:", error);
      }
    };

    fetchHubs();
  }, [showHubFilter]);

  const handleApplyFilters = () => {
    setCurrentPage(1);
    applyFilters?.();
    setShowFilterModal(false);
  };

  const handleRemoveFilters = () => {
    setDataFilter("");
    setSelectedHubIds?.([]);
    setCurrentPage(1);

    removeFilters?.();
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      {/* Search and Summary */}
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder="Search Vehicle Number"
            className="form-control"
            value={dataFilter}
            onChange={(e) => {
              setDataFilter(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>

        <div className="col-md-9 mb-2 d-flex align-items-center gap-2 flex-wrap">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            <i className="fa fa-filter me-1" aria-hidden="true" />
            Filter
          </button>

          <button type="button" className="btn btn-danger">
            Total Challans: {totalChallans}
          </button>

          <button type="button" className="btn btn-warning text-dark">
            Total Amount: ₹
            {Number(totalChallanAmount || 0).toLocaleString("en-IN")}
          </button>

          <button type="button" className="btn btn-danger">
            Pending Challans: {totalPendingChallans}
          </button>

          <button type="button" className="btn btn-warning text-dark">
            Pending Amount: ₹
            {Number(totalPendingChallanAmount || 0).toLocaleString("en-IN")}
          </button>
        </div>
      </div>

      {/* Server-side pagination */}
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationDefaultPage={currentPage}
        paginationRowsPerPageOptions={[5, 10, 20, 50]}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
          setCurrentPage(1);
        }}
        fixedHeader
        highlightOnHover
        responsive
        persistTableHead
        noDataComponent="No vehicle challans found."
      />

      {/* Filter Modal */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        hubs={hubs}
        selectedHubIds={selectedHubIds}
        setSelectedHubIds={setSelectedHubIds}
        showHubFilter={showHubFilter}
        applyFilters={handleApplyFilters}
        removeFilters={handleRemoveFilters}
      />
    </div>
  );
}
